import LocationEdit from "../Edits/LocationEdit";
import CmModal from "../Controls/CmModal";

export default function LocationEditModal({ locationId = 0, onClose }) {
  const id = Number.parseInt(locationId, 10) || 0;
  const title = id > 0 ? "Location" : "Add Location";

  return (
    <CmModal
      open
      bare
      onClose={onClose}
      title={title}
      size="form"
      testId="location-edit-modal"
    >
      <LocationEdit locationId={id} onClose={onClose} />
    </CmModal>
  );
}
